<template>
    <div class="gallery" :class="$screen.device" :id="galleryID">
            <a class="img"  v-for="(image, key) in imagesData" :key="key"
                    :href="image.largeURL"
                    :data-pswp-width="image.width"
                    :data-pswp-height="image.height"
                    target="_blank"
                    rel="noreferrer"
                    :style="{backgroundImage: `url(${image.thumbnailURL})`}"
            >
        </a>
    </div>

</template>

<script>
    import PhotoSwipeLightbox from 'photoswipe/lightbox';
    import 'photoswipe/style.css';
    import('photoswipe')

    export default {
        name: 'ImageGallery',
        props: {
            galleryID: String,
            images: Array,
        },
        data: () => ({
            lightbox:undefined,
        }),
        setup(props) {
            return {
                imagesData: props.images,
            };
        },
        mounted() {
            this.$nextTick(async ()=>{
                if (!this.lightbox) {
                    this.lightbox = new PhotoSwipeLightbox({
                        gallery: '#' + this.$props.galleryID,
                        children: 'a',
                        initialZoomLevel: 'fit',
                        secondaryZoomLevel: 'fit',
                        showHideAnimationType: 'fade',
                        pswpModule: () => import('photoswipe'),
                    });
                    this.lightbox.init();
                }
            })


        },
        unmounted() {
            if (this.lightbox) {
                this.lightbox.destroy();
                this.lightbox = null;
            }
        },
        methods: {
            start(){
                this.lightbox.loadAndOpen(0, {
                    gallery: document.querySelector('#' + this.$props.galleryID)
                });
            }
        },
    };
</script>

<style scoped>
    .gallery{display: grid; grid-auto-flow: column;  column-gap: 4px; min-height: 120px}
    .gallery.mobile{ min-height: 90px}
    .gallery>.img{background-size: cover; background-position: center;height: inherit; max-height: 200px; width: 100%;}
</style>